module.exports = __webpack_public_path__ + "img/today_sum0.01af4083.png";